import React from 'react';
import { Tooltip } from 'src/components';
import { CodeTooltipContent } from '../CodeTooltipContent';
import {
  getCodeColor,
  formatCode,
} from 'src/components/Strategy/shared/utils';
import type { CodeData } from 'src/components/Strategy/shared/types';

interface CodeWithTooltipProps {
  code: string;
  type: string;
  codeData?: CodeData;
}

const CodeWithTooltip = ({
  code,
  type,
  codeData,
}: CodeWithTooltipProps) => {
  const formattedCode = formatCode(code, type);
  const colorClass = getCodeColor(type);

  // If no data available yet, show code without tooltip
  if (!codeData) {
    return <span className={`font-medium ${colorClass}`}>{formattedCode}</span>;
  }

  return (
    <Tooltip
      slotProps={{
        containerClassName:
          'bg-white border border-neutral-200 shadow-xl rounded-lg',
        contentClassName: 'min-w-48 max-w-96 p-3',
      }}
      content={<CodeTooltipContent codeData={codeData} />}
      position="top"
    >
      <span className={`font-medium ${colorClass} cursor-pointer`}>
        {formattedCode}
      </span>
    </Tooltip>
  );
};

export default CodeWithTooltip;
